import idButlerPowerUp from 'app/scripts/data/butler-id';
//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class BoardPlugin extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'BoardPlugin';
  }

  isButler(): boolean {
    return this.get('idPlugin') === idButlerPowerUp;
  }
}
BoardPlugin.initClass();

export { BoardPlugin };
